import type { ImageItem } from '../../doc/schema';
import { useAssetUrl } from '../assets/localAssets';
import { pickVariant } from '../assets/variants';
import { usePane } from '../context';

/** Picks the image variant from the on-screen size at the last settled zoom. */
export function ImageBody({ item, width }: { item: ImageItem; width: number }) {
  const zoom = usePane((s) => s.settledZoom);
  const dpr = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
  const longestSide = Math.max(width, (width * item.props.naturalH) / Math.max(1, item.props.naturalW));
  const variant = pickVariant(longestSide * zoom * dpr);
  const url = useAssetUrl(item.props.assetId, variant);

  if (!url) return <div className="image-placeholder" />;
  return (
    <img
      className="image-img"
      src={url}
      alt=""
      draggable={false}
      style={{ opacity: item.props.opacity }}
      decoding="async"
    />
  );
}
